import API from '../apiCreate'
import { getParams } from '../getParams'
import type {
  RequestCreateLeadPaymentLink,
  ResponseLeadPaymentLink,
  ResponseLeadPaymentLinks,
  ResponseLeadPayments,
} from '../types/crm/crm.types'
import type { EmptyResponse, PaginationParam } from '../types/base.types'

/** Оплаты и ссылки на оплату лида: `/v1/crm-lead-payment*`. */
export const crmLeadPaymentApi = {
  getLeadPayments: (params: { user_id: number }) =>
    API.get<ResponseLeadPayments>(
      `crm-lead-payment/get-lead-payments/${getParams(params)}`,
    ),

  getLeadPaymentLinks: (params: {
    lead_id: number
    paramsPagination: PaginationParam
  }) =>
    API.get<ResponseLeadPaymentLinks>(
      `crm-lead-payment-link/get-links/${getParams(params)}`,
    ),
  getLeadPaymentLink: (link_id: number) =>
    API.get<ResponseLeadPaymentLink>(
      `crm-lead-payment-link/get-link/${link_id}`,
    ),
  createLeadPaymentLink: (data: RequestCreateLeadPaymentLink) =>
    API.post<EmptyResponse>('crm-lead-payment-link/create-link', data),
  deleteLeadPaymentLink: (link_id: number) =>
    API.post<EmptyResponse>(`crm-lead-payment-link/delete-link/${link_id}`),
}
